import { JSX, useCallback } from "react";

import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import CreateTextField from "utils/edit/CreateTextField";
import useFetch from "utils/fetch/useFetch";
import { ChangeEvent, DeleteEvent, Event } from "utils/history/Event";

import { SelectOption } from "../FieldService";
import SelectFormOption from "./SelectFormOption";

export type SelectFormOptionsProps = {
	editable: boolean;
	options: Array<SelectOption>;

	onAddOption: (option: SelectOption) => void;
	onRemoveOption: (index: number) => void;

	onChangeOption: (index: number, value: string) => void;
	onAddAttachment: (
		index: number,
		attachment: number,
		fileName: string
	) => void;
	onRemoveAttachment: (index: number, attachmentIndex: number) => void;
};

export default function SelectFormOptions(
	props: SelectFormOptionsProps
): JSX.Element {
	const addOption = useCallback(
		(value: string): void => {
			if (value === "") {
				return;
			}

			const option: SelectOption = {
				value: value,
				attachments: []
			};
			props.onAddOption(option);
		},
		[props.onAddOption]
	);

	return (
		<List dense={true}>
			{props.options.map((option, index) => (
				<SelectFormOption
					key={index}
					index={index}
					option={option}
					editable={props.editable}
					onChangeOption={props.onChangeOption}
					onRemoveOption={props.onRemoveOption}
					onAddAttachment={props.onAddAttachment}
					onRemoveAttachment={props.onRemoveAttachment}
				/>
			))}
			{props.editable && (
				<ListItem key={props.options.length}>
					<Grid container>
						<Grid item xs={9} sm={7} md={5} lg={4} xl={3}>
							<ListItemText>
								<CreateTextField
									fullWidth
									variant="standard"
									onCreate={addOption}
								/>
							</ListItemText>
						</Grid>
					</Grid>
				</ListItem>
			)}
		</List>
	);
}
